export const ContactData = {
    person: "",
    charge: "",
    email: "",
    phone: "",
}
export const OrganizationModel = {
    name: "",
    description: "",
    ilogo: "",
    lat:0,
    lng:0,
    timezone:"",
    token: "",
    contact: "",
    person: "",
    charge: "",
    email: "",
    phone: "",
    users: [],
    panels: []
}

